export interface Stock {
    id: number;
    name: string;
    screener: string;
    ltp: string;
    change_percent: string;
    open_price: string;
    volume: number;
    market_cap_cr: string;
    pe_ratio: string;
    industry_pe: string;
    high_52w: string;
    low_52w: string;
    returns_1m: string;
    returns_3m: string;
    returns_1y: string;
    returns_3y: string;
    returns_5y: string;
    pb_ratio: string;
    dividend: string;
    roe: string;
    roce: string;
    eps: string;
    dma_50: string;
    dma_200: string;
    rsi: string;
    margin_funding: string;
    margin_pledge: string;
    [key: string]: any;
  }
  
  const API_URL = process.env.REACT_APP_API_URL;
  
  export async function fetchMutualnames(): Promise<Stock[]> {
    try {
      const res = await fetch(`${API_URL}/auth/mutualstocks`);
      if (!res.ok) throw new Error("Failed to fetch mutual");
      const data = await res.json();
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  }